import { getOrigin } from './host';

export const getLanguageAgnosticHref = () =>
	getOrigin() + window.location.pathname;
